/**
 * Locale registry — the single source of truth for every language the product
 * supports. Adding a language later means: add its code here, create
 * `messages/<code>.json`, and register it in `src/i18n/messages.ts`.
 */
export const SUPPORTED_LOCALES = ['en', 'de', 'fr', 'es', 'it', 'nl', 'ru', 'tr'] as const

export type Locale = (typeof SUPPORTED_LOCALES)[number]

export const DEFAULT_LOCALE: Locale = 'en'

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value)
}

/** Coerce an untrusted value (DB column, query param) to a supported locale. */
export function toLocale(value: string | null | undefined): Locale {
  return isLocale(value) ? value : DEFAULT_LOCALE
}
